export const GENDERS = [
  'MALE',
  'FEMALE'];


// WEBPACK FOOTER //
// ./src/app/services/constants/gender-list.ts